import styled from "@emotion/styled";
import { useState } from "react";

import {
  Button,
  FONT_WEIGHT_SEMI_BOLD,
  Icon,
  Menu,
  MenuList,
  PAGE_SIDE_PADDING,
} from "@skilitics/designer-ui-components";

import { cardGap } from "./utils";

export const Card = ({ header, actions, children }: any) => {
  return (
    <CardContainer>
      <CardHeader>
        <CardLabel>{header}</CardLabel>
        {actions && <CardActions>{actions}</CardActions>}
      </CardHeader>
      <CardBody>
        <CardContent>{children}</CardContent>
      </CardBody>
    </CardContainer>
  );
};

const CardActions = ({ children }: any) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>();

  return (
    <>
      <CardActionsButton>
        <Icon icon="ellipsis-v" size={14} />
      </CardActionsButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MenuList>{children}</MenuList>
      </Menu>
    </>
  );
};

const CardActionsButton = styled(Button)`
  color: ${({ theme }) => theme.generalTextIcon};
  display: block;
  min-width: 0;
  width: 24px;
  height: 24px;
  flex: none;
  padding: 0;
`;

const CardContainer = styled.div`
  background: ${({ theme }) => theme.surface};
  border-radius: 8px;
  display: flex;
  flex-flow: column;
  padding: ${PAGE_SIDE_PADDING / 2}px;
  gap: 16px;
  height: 120px;
  flex: 1 1 calc(25% - ${cardGap}px);
  max-width: calc(33% - ${cardGap / 2}px);
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
`;

const CardBody = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
  align-items: end;
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  font-size: 16px;
`;

const CardContent = styled.div`
  display: flex;
  flex-flow: row;
  flex: 1;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
`;

const CardLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: ${({ theme }) => theme.generalTextIconVariant};
  flex: 1;
`;
